/*
 * @Author: WUJUN
 * @Date: 2019-10-25 11:15:10
 * @LastEditTime: 2022-05-20 09:46:41
 * @LastEditors: Please set LastEditors
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
const NODE_ENV = process.env.NODE_ENV;

import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store/';
// import 'lib-flexible'   //rem布局
import './perrmision';
import '@/utils/filter'; // 过滤器
// import '@/utils/errorProcessor'; // 错误处理
window.flag = false;
window.beginTime = new Date().getTime();
//自定义全局组件
import ftComponents from '_com/ftComponents';
import VueClipboard from 'vue-clipboard2';
import { Lazyload } from 'vant';
import '_com/dialog';
import './utils/vant';

// import '../static/js/login_plugin';
Vue.use(Lazyload, {
  error: '../static/img/error.png',
  loading: '../static/img/loading.png'
});
Vue.use(VueClipboard);
Vue.use(ftComponents);
Vue.config.productionTip = false;

if (NODE_ENV === 'production') {

  // 集成FTWeb前端监控脚本开始
  const _mst = window._mst || [];
  _mst.push('_vueInstall', Vue);
}

const app = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});
export default app;



// WEBPACK FOOTER //
// src/main.js